import { useEffect } from 'react';
import analyticsManager from '../utils/analytics/analyticsManager';

const AnalyticsProvider = ({ children }) => {
  useEffect(() => {
    const initializeAnalytics = async () => {
      try {
        await analyticsManager.initialize({
          googleAnalytics: {
            measurementId: process.env.REACT_APP_ANALYTICS_MEASUREMENT_ID,
            sampleRate: parseFloat(process.env.REACT_APP_ANALYTICS_SAMPLE_RATE) || 1.0,
            anonymizeIp: process.env.REACT_APP_ANALYTICS_ANONYMIZE_IP === 'true',
            respectDoNotTrack: process.env.REACT_APP_ANALYTICS_RESPECT_DNT === 'true',
            debug: process.env.REACT_APP_ANALYTICS_DEBUG === 'true',
            batchSize: parseInt(process.env.REACT_APP_ANALYTICS_BATCH_SIZE) || 10,
            batchTimeout: parseInt(process.env.REACT_APP_ANALYTICS_BATCH_TIMEOUT_MS) || 10000,
            offlineStorage: process.env.REACT_APP_ANALYTICS_OFFLINE_STORAGE === 'true',
            retryAttempts: parseInt(process.env.REACT_APP_ANALYTICS_RETRY_ATTEMPTS) || 3,
            retryDelay: parseInt(process.env.REACT_APP_ANALYTICS_RETRY_DELAY) || 1000
          }
        });
      } catch (error) {
        console.error('Failed to initialize analytics:', error);
      }
    };

    initializeAnalytics();
  }, []);

  return children;
};

export default AnalyticsProvider; 